//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import {
  ITwitterOAuthEndpointResponse,
  ITwitterSettingsResponse,
} from '@apis/twitter-settings/twitterSettingsApiModel';
import {
  serializedGatewayFetch,
  serializedSessionFetch,
} from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const TWITTER_BASE_URL = '/api/settings/twitter';

const TWITTER_DEFAULT_ENDPOINT = '/api/v1/';

const twitterGatewaySettingsFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'twitter_gateway',
    `${TWITTER_DEFAULT_ENDPOINT}${endpoint}`,
    init,
  );
};

/**
 * Creates mineables for the clients connected twitter account
 *
 * GET /api/v1/settings/create-mineables
 */
export const createTwitterV2Mineables = async (): Promise<void> => {
  await twitterGatewaySettingsFetch(`settings/create-mineables`, {
    method: 'POST',
  });
};

/**
 * Deletes mineables for the clients connected twitter account
 *
 * GET /api/v1/settings/remove-mineables
 */
export const removeTwitterV2Mineables = async (): Promise<void> => {
  await twitterGatewaySettingsFetch(`settings/remove-mineables`, {
    method: 'POST',
  });
};

function settingsFetch(endpoint: string, init?: RequestInit) {
  return serializedSessionFetch(`${TWITTER_BASE_URL}${endpoint}`, init);
}

/**
 * Gets twitter settings for the current client
 *
 * GET /api/settings/twitter
 */
export async function getTwitterSettings(): Promise<ITwitterSettingsResponse> {
  const res = await settingsFetch('');
  return await res.json();
}

/**
 * Gets the twitter oauth endpoint
 * /api/settings/twitter/oauth
 *
 * @returns the url to direct a user to to oauth twitter
 */
export async function getTwitterOAuthEndpoint(): Promise<ITwitterOAuthEndpointResponse> {
  const res = await settingsFetch(`/oauth`, {
    method: 'GET',
  });
  return await res.json();
}

/**
 * handles the response after a user has oauth'ed on twitter
 * /api/settings/twitter/oauth/response
 *
 * @returns
 */
export async function handleTwitterOAuthResponse(): Promise<void> {
  await settingsFetch(`/oauth/response`, {
    method: 'GET',
  });
}

/**
 * Deauths the clients twitter username
 * /api/settings/twitter/deauth/${username}
 *
 */
export async function deauthTwitter(username: string): Promise<void> {
  await settingsFetch(`/deauth/${username}`, {
    method: 'POST',
  });
}
